import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { FormButton } from "@/components/form/FormButton";
import { useHintHover } from "@/components/hints/useHintHover";
import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { useStore } from "@/store";
import { trackEvent } from "@/utils/trackEvent";
import { twMerge } from "@/utils/twMerge";

export const ShareButton = observer(function ShareButton() {
  const t = useTranslations();
  const { dialog, doc, view } = useStore();
  const hintHandlers = useHintHover("shareDocument");
  const { shareDialog } = dialog;

  const handleShareClick = () => {
    if (doc?.id) {
      trackEvent("share_button_clicked", { doc_id: doc.id });
    }
    shareDialog.open();
  };

  return view.isRightSidebarCollapsed ? (
    <Sidebar.Button
      icon={
        <Icon
          name="Upload"
          className="[--color-icon-main:var(--color-icon-active)] [--color-icon-secondary:var(--color-icon-active)]"
        />
      }
      title={t("sidebar.share")}
      onClick={handleShareClick}
      className={twMerge(
        "rounded-8 bg-blue-100 dark:bg-blue-900",
        "hover:bg-blue-200 dark:hover:bg-blue-800 focus:bg-blue-200 dark:focus:bg-blue-800",
      )}
      hintKey="shareDocument"
      tooltipPlacement="left"
    />
  ) : (
    <FormButton
      onClick={handleShareClick}
      aria-label={t("sidebar.openShareMenu")}
      variant="accent"
      className="rounded-8 h-full"
      {...hintHandlers}
    >
      <div className="m-auto tracking-tight text-sm">{t("sidebar.share")}</div>
    </FormButton>
  );
});
